export interface State {
    fingerPrint?: string,
}

export const initialState: State = {};
